import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-my-space',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './my-space.component.html',
  styleUrl: './my-space.component.scss'
})
export class MySpaceComponent {
  constructor (private AuthService: AuthService, private router: Router){}

  logout(): void{
    this.AuthService.logout();
   this.router.navigate(['/login']); 
  }
}
